import React from "react"

import "./LoadingBar.css"

function LoadingBar(props) {
    return props.loading ? <div className="table__loader" /> : null
}

export default LoadingBar
